import { Switch } from 'antd-mobile';
import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';

import { MemberDiscount } from 'src/common/member-discount/MemberDiscount';

import OfficialPage from '../OfficialPage';
import { TopNav } from '@common/top-nav/TopNav';
import './ExchangeCouponDetailOrder.less';

export default class ExchangeCouponDetailOrder extends OfficialPage {
  state = {
    useBalance: true,
    balance: '',
    couponId: '',
    couponDetail: '',
    payInfo: '',
    discountList: [],
    isFromSelectAddress: false,
    franchisee_id: '',
    cart_id_arr: [],
    cart_data_arr: [],
    balance: '',
    requesting: false,
    additional_info: {},
    is_group: '',
    inputTimer: '',
    style: '', // 兑换券样式存储
    exchangeCouponData: {
      dialogHidden: true,
      goodsInfo: {},
      selectModelInfo: {},
      hasSelectGoods: false,
      voucher_coupon_goods_info: {}
    }
  }
  hasRequiredSuppInfo = false

  memberDiscountRef = React.createRef();

  constructor(props) {
    super(props);
    document.title = '确认订单';
  }
  

  componentWillMount(options = getCurrentPageQueryParams()) {
    let that = this
    let id = options.id
    let exchangeCouponDetail = app.globalData.exchangeCouponStyle
    let style = {}
    if (exchangeCouponDetail) {
      let styleArr = this.cutStyle(exchangeCouponDetail.style)
      style.strStyle = styleArr
      style.lineBackgroundColor =
        exchangeCouponDetail.customFeature.lineBackgroundColor
      style.secColor = exchangeCouponDetail.customFeature.secColor
    }
    that.setData({
      couponId: id,
      style: style
    })
    this.getExchangeCouponInfo()
    this.getPayInfo()
  }

  cutStyle = str => {
    if (typeof str !== 'string') {
      return str;
    }
    // 截取style样式
    let obj = str.split(';').reduce((p, e) => {
      let [k, v] = e.split(':')
      v = (v && v.trim()) || ''
      if (v) {
        p[k] = v
      }
      return p
    }, {})
    return obj
  }
  getExchangeCouponInfo = () => {
    // 兑换券详情
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/GetCouponInfo',
      data: {
        app_id: app.globalData.appId,
        coupon_id: that.data.couponId
      },
      hideLoading: true,
      success: function (res) {
        that.setCouponData(res.data)
      }
    })
  }
  setCouponData = data => {
    // 处理兑换券的使用方式
    let that = this
    let useCondition = ''
    if (data.type == 0) {
      useCondition = '满' + data.condition + '，减' + data.value + '元'
    } else if (data.type == 1) {
      useCondition = '打' + data.value + '折'
    } else if (data.type == 2) {
      useCondition = '可抵扣' + data.value + '元'
    } else if (data.type == 3) {
      if (data.extra_condition == '') {
        useCondition = '直接兑换' + data.coupon_goods_info.title
      } else if (data.extra_condition.price) {
        useCondition =
          '消费满' +
          data.extra_condition.price +
          '元可兑换' +
          data.coupon_goods_info.title
      } else if (data.extra_condition.goods_id) {
        useCondition =
          '购买' +
          data.condition_goods_info.title +
          '可兑换' +
          data.coupon_goods_info.title
      }
    } else if (data.type == 4) {
      useCondition = '储值金可充值' + data.value + '元'
    } else if (data.type == 5) {
      useCondition = data.extra_condition
    }
    let newData = data
    newData['useCondition'] = useCondition
    that.setData({
      couponDetail: newData
    })
  }
  useBalanceChange = checked => {
    // 是否使用储值金
    this.setData({
      useBalance: checked
    })
    this.changePayInfo()
  }
  changePayInfo = () => {
    // 改变支付优惠
    let that = this
    app.sendRequest({
      url: '/index.php?r=appCoupon/calculateCouponPrice',
      data: {
        app_id: app.globalData.appId,
        id: that.data.couponId,
        select_benefit: that.data.selectDiscountInfo.no_use_benefit
          ? 'no_use_benefit'
          : '',
        no_use_balance: that.data.useBalance ? 0 : 1,
        'select_benefit[discount_type]':
          that.data.selectDiscountInfo.discount_type,
        'select_benefit[vip_id]': that.data.selectDiscountInfo.vip_id,
        'select_benefit[coupon_id]': that.data.selectDiscountInfo.coupon_id,
        'select_benefit[discount_title]':
          that.data.selectDiscountInfo.discount_title
      },
      hideLoading: true,
      method: 'post',
      success: function (res) {
        let newData = res.data
        that.setData({
          payInfo: newData,
          balance: newData.balance
        })
      }
    })
  }
  getPayInfo = () => {
    // 第一次拿取支付信息
    let that = this
    app.sendRequest({
      url: '/index.php?r=appCoupon/calculateCouponPrice',
      data: {
        app_id: app.globalData.appId,
        id: that.data.couponId
      },
      hideLoading: true,
      method: 'post',
      success: function (res) {
        let newData = res.data
        let info = res.data
        let benefits = info.benefit
        let goodsBenefitsData = []
        let selectDiscountInfo = {}
        if (info.selected_benefit) {
          selectDiscountInfo = {
            discount_title: info.selected_benefit.discount_title,
            discount_type: info.selected_benefit.discount_type,
            coupon_id: info.selected_benefit.coupon_id,
            vip_id: info.selected_benefit.vip_id
          }
        }
        benefits.coupon_benefit && benefits.coupon_benefit.length
          ? goodsBenefitsData.push({
            label: 'coupon',
            value: benefits.coupon_benefit
          })
          : ''
        benefits.all_vip_benefit && benefits.all_vip_benefit.length
          ? goodsBenefitsData.push({
            label: 'vip',
            value: benefits.all_vip_benefit
          })
          : ''
        that.setData({
          balance: newData.balance,
          payInfo: newData,
          discountList: goodsBenefitsData,
          selectDiscountInfo: selectDiscountInfo
        })
      },
      complete: function (res) {
        if (res.status === 0) {
          return
        }
        setTimeout(() => {
          app.turnBack()
        }, 1000)
      }
    })
  }
  confirmPayment = e => {
    var list = this.data.goodsList,
      that = this,
      no_use_balance = that.data.useBalance ? 0 : 1,
      selected_benefit = this.data.selectDiscountInfo.discount_type
        ? ''
        : 'no_use_benefit'
    if (this.requesting) {
      return
    }
    let data
    this.requesting = true
    if (selected_benefit == '') {
      data = {
        app_id: app.globalData.appId,
        id: that.data.couponId,
        'select_benefit[discount_type]':
          that.data.selectDiscountInfo.discount_type,
        'select_benefit[vip_id]': that.data.selectDiscountInfo.vip_id,
        'select_benefit[coupon_id]': that.data.selectDiscountInfo.coupon_id,
        'select_benefit[discount_title]':
          that.data.selectDiscountInfo.discount_title,
        no_use_balance: no_use_balance
      }
    } else {
      data = {
        app_id: app.globalData.appId,
        id: that.data.couponId,
        select_benefit: selected_benefit,
        'select_benefit[discount_type]':
          that.data.selectDiscountInfo.discount_type,
        'select_benefit[vip_id]': that.data.selectDiscountInfo.vip_id,
        'select_benefit[coupon_id]': that.data.selectDiscountInfo.coupon_id,
        'select_benefit[discount_title]':
          that.data.selectDiscountInfo.discount_title,
        no_use_balance: no_use_balance
      }
    }
    app.sendRequest({
      url: '/index.php?r=appCoupon/addCouponOrder',
      method: 'post',
      data: data,
      success: function (res) {
        that.payOrder(res.data)
      },
      fail: function () {
        that.requesting = false
      },
      successStatusAbnormal: function () {
        that.requesting = false
      }
    })
  }
  cancelOrder = orderId => {
    var appId = app.getAppId(),
      that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/cancelOrder',
      data: {
        order_id: orderId,
        app_id: appId,
        sub_shop_app_id: appId
      },
      success: function (res) { }
    })
  }
  payOrder = orderId => {
    var that = this
    function paySuccess() {
      app.showModal({ content: '兑换成功！' })
      setTimeout(() => {
        app.turnBack()
      }, 1000)
    }
    function payFail() {
      app.showModal({ content: '兑换失败！' })
      that.cancelOrder(orderId.order_id)
      setTimeout(() => {
        app.turnBack()
      }, 1000)
    }
    if (orderId.total_price == 0) {
      app.showModal({ content: '兑换成功！' })
      setTimeout(() => {
        app.turnBack()
      }, 1000)
      return
    }
    // app.sendRequest({
    //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
    //   data: {
    //     order_id: orderId.order_id
    //   },
    //   success: function (res) {
    //     var param = res.data
    //     param.orderId = orderId.order_id
    //     param.success = paySuccess
    //     param.goodsType = 0
    //     param.fail = payFail
    //     that.wxPay(param)
    //   },
    //   fail: function () {
    //     payFail()
    //   },
    //   successStatusAbnormal: function () {
    //     payFail()
    //   }
    // })
    app.goPay({
      orderId: orderId.order_id,
      cancel: payFail
    })
  }
  wxPay = param => {
    var that = this
    app.requestPayment({
      timeStamp: param.timeStamp,
      nonceStr: param.nonceStr,
      package: param.package,
      signType: param.signType,
      paySign: param.paySign,
      success: function (res) {
        app.wxPaySuccess(param)
        param.success()
      },
      fail: function (res) {
        if (res.errMsg === 'requestPayment:fail cancel') {
          app.showModal({
            content: '支付已取消'
          })
          that.cancelOrder(param.orderId)
          setTimeout(() => {
            app.turnBack()
          }, 1000)
          return
        }
        app.showModal({
          content: '支付失败'
        })
        setTimeout(() => {
          app.turnBack()
        }, 1000)
        app.wxPayFail(param, res.errMsg)
      }
    })
  }
  showMemberDiscount = () => {
    this.memberDiscountRef.current.show({
      discountType: discountList,
      afterSelectedBenefit: this.afterSelectedBenefit
    })
    this.memberDiscountRef.current.showDialog(this.data.selectDiscountInfo);
  }
  afterSelectedBenefit = event => {
    this.setData({
      selectDiscountInfo: event.detail.selectedDiscount
    })
    this.changePayInfo()
  }

  render() {
    const {
      showGetUserInfo,
      discountList,
      style,
      couponDetail,
      data,
      payInfo,
      selectDiscountInfo,
      selectDiscountIndex,
      useBalance,
      balance
    } = this.state
    return (
      <React.Fragment>
        <div className="official-page exchange-coupon-detail-order">
          <TopNav title="确认下单" />
          <div className="preview-goods-wrap">
            <div className="exchange-coupon">
              <div className="exchange-coupon-wrapper">
                {couponDetail.recv_status == 1 ? (
                  <div
                    className="exchange-coupon-linetop"
                    style={convertLineStyleData('background:' + style.secColor)}
                  ></div>
                ) : (
                    couponDetail.recv_status == 0 && (
                      <div
                        className="exchange-coupon-linetop"
                        style={convertLineStyleData('background-color:#CCCCCC')}
                      ></div>
                    )
                  )}
                <div
                  className="exchange-coupon-top"
                  style={convertLineStyleData('background-color: ' + style.lineBackgroundColor)}
                >
                  <div className="exchange-coupon-left">
                    <div className="exchange-coupon-left-first">
                      {couponDetail.title}
                    </div>
                    {couponDetail.recv_status == 1 ? (
                      <div
                        className="exchange-coupon-left-second"
                        style={convertLineStyleData(
                          'color:' +
                          (style.strStyle && style.strStyle.color) +
                          ';font-size:' +
                          (style.strStyle && style.strStyle['font-size'])
                        )}
                      >
                        {couponDetail.exchange_condition.price > 0 && (
                          <span>
                            {'¥' + couponDetail.exchange_condition.price}
                          </span>
                        )}
                        {couponDetail.exchange_condition.price > 0 &&
                          !!+couponDetail.exchange_condition.integral &&
                          couponDetail.exchange_condition.integral > 0 && (
                            <span>+</span>
                          )}
                        {!!+couponDetail.exchange_condition.integral &&
                          couponDetail.exchange_condition.integral > 0 && (
                            <span>
                              {couponDetail.exchange_condition.integral + '积分'}
                            </span>
                          )}
                      </div>
                    ) : (
                        couponDetail.recv_status == 0 && (
                          <div
                            className="exchange-coupon-left-second"
                            style={convertLineStyleData('color:#333')}
                          >
                            {couponDetail.exchange_condition.price > 0 && (
                              <span>
                                {'¥' + couponDetail.exchange_condition.price}
                              </span>
                            )}
                            {couponDetail.exchange_condition.price > 0 &&
                              !!+couponDetail.exchange_condition.integral &&
                              couponDetail.exchange_condition.integral > 0 && (
                                <span>+</span>
                              )}
                            {!!+couponDetail.exchange_condition.integral &&
                              couponDetail.exchange_condition.integral > 0 && (
                                <span>
                                  {couponDetail.exchange_condition.integral +
                                    '积分'}
                                </span>
                              )}
                          </div>
                        )
                      )}
                  </div>
                  {couponDetail.type == 1 && couponDetail.recv_status == 1 ? (
                    <div
                      className="exchange-coupon-icon"
                      style={convertLineStyleData('background-color:' + style.secColor)}
                    >
                      <div>折</div>
                    </div>
                  ) : couponDetail.type == 1 && couponDetail.recv_status == 0 ? (
                    <div className="exchange-coupon-icon exchange-coupon-icon-used">
                      <div>折</div>
                    </div>
                  ) : couponDetail.type == 2 && couponDetail.recv_status == 1 ? (
                    <div
                      className="exchange-coupon-icon"
                      style={convertLineStyleData('background-color:' + style.secColor)}
                    >
                      <div>代</div>
                    </div>
                  ) : couponDetail.type == 2 && couponDetail.recv_status == 0 ? (
                    <div className="exchange-coupon-icon exchange-coupon-icon-used">
                      <div>代</div>
                    </div>
                  ) : couponDetail.type == 0 && couponDetail.recv_status == 1 ? (
                    <div
                      className="exchange-coupon-icon"
                      style={convertLineStyleData('background-color:' + style.secColor)}
                    >
                      <div>减</div>
                    </div>
                  ) : couponDetail.type == 0 && couponDetail.recv_status == 0 ? (
                    <div className="exchange-coupon-icon exchange-coupon-icon-used">
                      <div>减</div>
                    </div>
                  ) : couponDetail.type == 3 && couponDetail.recv_status == 1 ? (
                    <div
                      className="exchange-coupon-icon"
                      style={convertLineStyleData('background-color:' + style.secColor)}
                    >
                      <div>兑</div>
                    </div>
                  ) : couponDetail.type == 3 && couponDetail.recv_status == 0 ? (
                    <div className="exchange-coupon-icon exchange-coupon-icon-used">
                      <div>兑</div>
                    </div>
                  ) : couponDetail.type == 4 && couponDetail.recv_status == 1 ? (
                    <div
                      className="exchange-coupon-icon"
                      style={convertLineStyleData('background-color:' + style.secColor)}
                    >
                      <div>储</div>
                    </div>
                  ) : couponDetail.type == 4 && couponDetail.recv_status == 0 ? (
                    <div className="exchange-coupon-icon exchange-coupon-icon-used">
                      <div>储</div>
                    </div>
                  ) : couponDetail.type == 5 && couponDetail.recv_status == 1 ? (
                    <div
                      className="exchange-coupon-icon"
                      style={convertLineStyleData('background-color:' + style.secColor)}
                    >
                      <div>通</div>
                    </div>
                  ) : couponDetail.type == 5 && couponDetail.recv_status == 0 ? (
                    <div className="exchange-coupon-icon exchange-coupon-icon-used">
                      <div>通</div>
                    </div>
                  ) : couponDetail.type == 6 && couponDetail.recv_status == 1 ? (
                    <div
                      className="exchange-coupon-icon"
                      style={convertLineStyleData('background-color:' + style.secColor)}
                    >
                      <div>次</div>
                    </div>
                  ) : (
                                              couponDetail.type == 6 &&
                                              couponDetail.recv_status == 0 && (
                                                <div className="exchange-coupon-icon exchange-coupon-icon-used">
                                                  <div>次</div>
                                                </div>
                                              )
                                            )}
                  {couponDetail.recv_status == 1 ? (
                    <div
                      className="exchange-coupon-icon-wrapper"
                      style={convertLineStyleData('border-color:' + style.secColor)}
                    ></div>
                  ) : (
                      couponDetail.recv_status == 0 && (
                        <div
                          className="exchange-coupon-icon-wrapper"
                          style={convertLineStyleData('background-color:#ccc')}
                        ></div>
                      )
                    )}
                </div>
                <div
                  className="exchange-coupon-bottom"
                  style={convertLineStyleData('background-color: ' + style.lineBackgroundColor)}
                >
                  <div className="exchange-coupon-cut" style={data ? convertLineStyleData(data.style) : {}}></div>
                  <div className="desc">
                    {'有效期 ' +
                      (couponDetail.expire == '-1'
                        ? couponDetail.start_use_date +
                        '至' +
                        couponDetail.end_use_date
                        : couponDetail.expire == '0'
                          ? '领取当天生效,有效期1天'
                          : '领取' +
                          (couponDetail.react > 0
                            ? couponDetail.react + '天后'
                            : '当天') +
                          '生效，有效期' +
                          (couponDetail.expire || '') +
                          '天') +
                      ' ' +
                      (couponDetail.exclude_holiday == 0
                        ? ''
                        : '除去法定节假日') +
                      ' ' +
                      (couponDetail.exclude_weekend == 0 ? '' : '周一至周五') +
                      ' ' +
                      (couponDetail.start_use_time || '') +
                      '-' +
                      (couponDetail.end_use_time || '')}
                  </div>
                </div>
              </div>
            </div>
            <div className="preview-box">
              <div className="single-box">
                商品金额
                <span className="pull-right">
                  <span>{'¥' + (payInfo.original_price || '')}</span>
                  {payInfo.integral != 0 && <span>+</span>}
                  {payInfo.integral != 0 && (
                    <span>{(payInfo.integral || '') + '积分'}</span>
                  )}
                </span>
              </div>
              {((payInfo.benefit && payInfo.benefit.all_vip_benefit.length != 0) ||
                (payInfo.benefit && payInfo.benefit.coupon_benefit.length != 0)) && (
                  <div onClick={this.showMemberDiscount}>
                    <div className="balance-switch">
                      <span>优惠方式</span>
                      <div className="ico-moon icon-rightarrow pull-right"></div>
                      <span className="pull-right">
                        {selectDiscountInfo.discount_title ||
                          selectDiscountInfo.title}
                      </span>
                    </div>
                    <div
                      hidden={selectDiscountIndex == 0}
                      className="balance-price"
                    >
                      <span className="pull-right">
                        {'- ¥' + payInfo.discount_price}
                      </span>
                    </div>
                  </div>
                )}
              <div>
                <div className="balance-switch">
                  <span>使用储值金</span>
                  <Switch
                    className="pull-right"
                    checked={useBalance}
                    onChange={this.useBalanceChange}
                  ></Switch>
                </div>
                <div hidden={!useBalance} className="balance-price">
                  <span className="pull-right">{'- ¥' + balance}</span>
                </div>
              </div>
            </div>
            <div className="bottom-nav">
              <div className="preview-goods-total-price">
                合计:
                <span className="price-count">{'¥' + (payInfo.final_price || '')}</span>
              </div>
              <form>
                <button type="button" onClick={this.confirmPayment}>立即付款</button>
              </form>
            </div>
          </div>
        </div>

        <MemberDiscount ref={this.memberDiscountRef} />
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/exchange-coupon-detail-order/ExchangeCouponDetailOrder.jsx